<app-content-header [configuration]="headerConfig"></app-content-header>
<div class="flex flex-col items-start p-2 max-w-6xl mx-2">
  <h1 class="text-2xl text-left mb-6">
    <p [innerHTML]="'support.frequentlyAskedQuestions' | translate"></p>
  </h1>
  <mat-accordion class="w-full">
    <mat-expansion-panel class="w-full px-6 py-4 m-0">
      <mat-expansion-panel-header>
        <mat-panel-title class="flex-items-center">
          <mat-icon class="mr-2">help</mat-icon>
          <p
            [innerHTML]="'support.questions.supportEmergencyQ' | translate"
          ></p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="'answers.supportEmergencyA' | translate"></p>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-full px-6 py-4 m-0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="mr-2">help</mat-icon>
          <p [innerHTML]="'support.questions.cannotLoginQ' | translate"></p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="'answers.cannotLoginA' | translate"></p>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-full px-6 py-4 m-0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="mr-2">help</mat-icon>
          <p [innerHTML]="'support.questions.moveIsStuckQ' | translate"></p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="'answers.moveIsStuckA' | translate"></p>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-full px-6 py-4 m-0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="mr-2">help</mat-icon>
          <p
            [innerHTML]="'support.questions.tabletNotRespondingQ' | translate"
          ></p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="'answers.tabletNotRespondingA' | translate"></p>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-full px-6 py-4 m-0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="mr-2">help</mat-icon>
          <p
            [innerHTML]="'support.questions.trainingMaterialsQ' | translate"
          ></p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="'answers.trainingMaterialsA' | translate"></p>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-full px-6 py-4 m-0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="mr-2">help</mat-icon>
          <p [innerHTML]="'support.questions.majorOutageQ' | translate"></p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="'answers.majorOutageA' | translate"></p>
    </mat-expansion-panel>
  </mat-accordion>
  <p [innerHTML]="'support.emailUs' | translate" class="mt-6 text-center"></p>
</div>
